import React from "react";
import { Modal, Button, Alert } from "react-bootstrap";
import AsyncButton from "common/ui/AsyncButton";

interface ErpIdVerificationModalProps {
    erpId: string;
    isErpAvailable: boolean;
    message: string;
    onClose: () => void;
    onVerify: () => Promise<void>;
    onSaveWithoutVerification: () => void;
    onRetry: () => Promise<void>;
}

const ErpIdVerificationModal: React.FC<ErpIdVerificationModalProps> = (props: ErpIdVerificationModalProps) => {
    const isErpDown = !props.isErpAvailable;

    return <Modal show onHide={props.onClose} backdrop="static">
        <Modal.Header closeButton>
            <Modal.Title>{isErpDown ? 'ERP System Unavailable' : 'ERP Contract ID Not Verified'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Alert variant={isErpDown ? 'danger' : 'warning'}>
                <strong>{isErpDown ? 'Unable to verify ERP ID' : 'ERP Contract ID is not verified'}</strong>
                <div className="mt-2">{props.message}</div>
            </Alert>
            {isErpDown ? (
                <>
                    <p>The ERP system is currently unavailable. What would you like to do?</p>
                    <ul>
                        <li><strong>Retry:</strong> Try to connect to the ERP system again</li>
                        <li><strong>Save Anyway:</strong> Save the ERP ID without verification (you can verify it later)</li>
                        <li><strong>Cancel:</strong> Discard the ERP ID and close</li>
                    </ul>
                </>
            ) : (
                <>
                    <p>The ERP ID <strong>{props.erpId}</strong> has been saved but could not be verified with the ERP system.</p>
                    <p>What would you like to do?</p>
                    <ul>
                        <li><strong>Verify ERP ID:</strong> Try to verify the ID with the ERP system</li>
                        <li><strong>Save Anyway:</strong> Keep the ERP ID without verification (you can verify it later)</li>
                        <li><strong>Cancel:</strong> Close this dialog</li>
                    </ul>
                </>
            )}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={props.onClose}>
                Cancel
            </Button>

            <Button variant="secondary" onClick={props.onSaveWithoutVerification}>
                Save Anyway
            </Button>

            <AsyncButton variant="primary" onClickAsync={isErpDown ? props.onRetry : props.onVerify}>
                {isErpDown ? 'Retry' : 'Verify ERP ID'}
            </AsyncButton>
        </Modal.Footer>
    </Modal>
}

export default ErpIdVerificationModal;